module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-staying-on-track-large@3x.ca02cea2.png";